var _circle, _circle2, _g, _circle3, _g2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnviroment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#86F7FF",
    fillOpacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.85,
    stroke: "#86F7FF",
    strokeOpacity: 0.2,
    strokeWidth: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_478_76704)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.3913,
    stroke: "#86F7FF",
    strokeOpacity: 0.6,
    strokeWidth: 1.04348
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.3913,
    stroke: "#86F7FF",
    strokeWidth: 1.04348
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_478_76704)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3833 9.79386L10.1886 6.67676H17.5968L17.5968 6.67676V8.78182L14.2778 11.6835L14.4189 11.6763L17.617 12.1216L17.5968 12.1391V14.2266L14.0546 17.3235V15.2387L16.4184 13.1585L14.0344 15.2211V17.3235H6.38331V15.178L8.8527 14.8136V12.3038L6.38331 11.8989V9.79389H14.0344V11.696L14.0546 11.695V9.79386L14.0546 9.79386H6.3833Z",
    fill: "#86F7FF",
    fillOpacity: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2006 8.4C15.1726 8.4 16.291 9.6592 16.4534 11.1792H16.503C17.7718 11.1792 18.8006 12.1688 18.8006 13.3896C18.8006 14.6104 17.7718 15.6 16.503 15.6H9.89822C8.62942 15.6 7.60062 14.6104 7.60062 13.3896C7.60062 12.1688 8.62942 11.1792 9.89822 11.1792H9.94782C10.1118 9.6488 11.2286 8.4 13.2006 8.4ZM11.1142 6C12.279 6 13.295 6.6624 13.7966 7.636C13.5989 7.61164 13.3998 7.59962 13.2006 7.6C11.2886 7.6 9.89502 8.6456 9.39742 10.2288L9.34782 10.4L9.31102 10.5496L9.17902 10.5736C8.6958 10.6717 8.24443 10.8881 7.86526 11.2033C7.48609 11.5185 7.19095 11.9228 7.00622 12.38C6.62511 12.1478 6.32799 11.8001 6.15804 11.3875C5.9881 10.9748 5.95419 10.5187 6.06126 10.0855C6.16832 9.65222 6.41077 9.26442 6.75336 8.97842C7.09595 8.69243 7.52082 8.52315 7.96622 8.4952L8.14382 8.4912C8.26718 7.79306 8.63254 7.1607 9.17574 6.70513C9.71894 6.24956 10.4053 5.9999 11.1142 6Z",
    fill: "url(#paint0_linear_478_76704)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_478_76704",
    x: -0.0000424385,
    y: -0.0000424385,
    width: 24.0001,
    height: 24.0001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.04348,
    result: "effect1_foregroundBlur_478_76704"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_478_76704",
    x: 0.957214,
    y: 1.25067,
    width: 22.0861,
    height: 21.4989,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.71304,
    result: "effect1_foregroundBlur_478_76704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_478_76704",
    x1: 14.3033,
    y1: 6.8051,
    x2: 8.4074,
    y2: 17.1082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnviroment);
export default __webpack_public_path__ + "static/media/enviroment.e3cabaae4a95605da940839520a766a5.svg";
export { ForwardRef as ReactComponent };